import { LitElement, html, TemplateResult, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { DimensionOption } from './model/dimension-option-type';
import { dimensionStyles } from './styles/dimension-styles';


@customElement('dimension-group-element')
export class DimensionGroupElement extends JobindsatsElement(LitElement) {

    static styles = [dimensionStyles, css`
        ul {
            padding-left: 12px;
        }
    `];

    @state()
    hoveredGroupId?: string;

    @property()
    group?: DimensionOption;

    render() {
        if (!this.group) {
            return html``;
        }
        const group = this.group;
        if (group.children?.length) {
            return this.renderGroup(group);
        } else {
            return this.renderDimensionOptions([group]);
        }
    }

    renderGroup(group: DimensionOption): TemplateResult {
        return html`
            <span><input type="checkbox" id="${group.id}" class=${this.hoveredGroupId === group.id ? 'hovered' : ''} 
                    @change=${() => this.handleOptionSelection(group.id)} .checked=${group.selected}></span>
            <label @click="${(ev: Event) => {ev.preventDefault(); ev.stopPropagation();}}" class="select-group-button" for="${group.id}" @mouseenter=${() => {
                    this.hoveredGroupId = group.id;}} @mouseleave=${() => {this.hoveredGroupId = undefined;}}>
                    <strong><a href="#!" role="button" @click=${() => this.handleGroupSelection(group.id)} >${group.name}</a></strong></label>
            <ul>
                ${group.children?.map(child => {
                if (child.children?.length) {
                    return html`
                        <li>
                            ${this.renderGroup(child)}
                        </li>
                    `;
                } else {
                    return this.renderDimensionOptions([child]);
                }
            })}
            </ul>
        `;
    }

    handleOptionSelection(key: string) {
        const dimensionSelectedEvent = new CustomEvent('option-selected',
            {
                detail: {
                    key,
                },
                composed: true,
                bubbles: true,
            });
        this.dispatchEvent(dimensionSelectedEvent);
    }

    handleGroupSelection(key: string) {
        const dimensionSelectedEvent = new CustomEvent('group-selected',
            {
                detail: {
                    key,
                },
                composed: true,
                bubbles: true,
            });
        this.dispatchEvent(dimensionSelectedEvent);
    }

    renderDimensionOptions(options: DimensionOption[]) {

        return html`${repeat(options,
            (option) => option.id,
            (option, idx) => html`<li> 
                                <span><input @click=${() => this.handleOptionSelection(option.id)} 
                                        type="checkbox" id="${option.id}" .checked=${option.selected}></span>
                                <label for="${option.id}"> ${option.name}</label></li>`)}`;
    }
}